import React from 'react';
import classNames from 'classnames';
import RangeFilterWrapper from 'components/RangeFilterWrapper';
import { useTranslation } from 'react-i18next';
import CashIcon from 'icons/Cash.icon';
import { PriceRangeCustomApply } from 'components/RangeFilterWrapper/RangeFilterWrapper.component';
import { FilterActionWrapperProps } from '../FilterActionWrapper/FilterActionWrapper.component';

import './PriceRangeFilter.styles.scss';

type PriceRangeFilterProps = {
  className?: string;
  title?: string;
  showIcon?: boolean;
} & PriceRangeCustomApply &
  Partial<FilterActionWrapperProps>;

export const TWO_MIL = 2000000;
export const FIVE_MIL = 5000000;
export const PRICE_RANGE_STATE_VALS = {
  UNDER_MIN: 'under2m',
  BETWEEN_VALUES: '2to5m',
  ABOVE_MAX: 'above5m',
};

const PriceRangeFilter: React.FC<PriceRangeFilterProps> = (props) => {
  const { className, title, showIcon = true, ...rest } = props;
  const { t } = useTranslation();

  const classes = classNames('price-range-filter', className);

  return (
    <RangeFilterWrapper
      className={classes}
      paramsKeywords={{ fromKeyword: 'from', toKeyword: 'to' }}
      triggerText={title || t('price')}
      applyButtonText={t('applyPriceFilter')}
      selectValues={{
        minValue: TWO_MIL,
        maxValue: FIVE_MIL,
        copies: PRICE_RANGE_STATE_VALS,
      }}
      {...(showIcon && { triggerIcon: CashIcon })}
      {...rest}
    />
  );
};

export default PriceRangeFilter;
